export const DEFAULT_UUID = '00000000-0000-0000-0000-000000000000'

export const isTruthyUUID = (uuid?: string): boolean => !!uuid && uuid !== DEFAULT_UUID
